var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimetrackingplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_9687)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#28519E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6709 7.33154V18.6685L19.5785 13L10.6709 7.33154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_9687"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimetrackingplay);
export default __webpack_public_path__ + "static/media/time trackingplay.6a59b7ad7587f5fb434171ac9b95389c.svg";
export { ForwardRef as ReactComponent };